import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildingBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBuildingBlocks"><Path d="M21.5 6.5L13 2L2.5 8.5V17L11 22L21.5 15V6.5Z" stroke="currentColor"/><Path d="M21.5 6.5L11 13.5L2.5 8.5" stroke="currentColor"/><Path d="M11 22V13.5" stroke="currentColor"/><Path d="M2.5 12.75L11 17.75L21.5 10.75" stroke="currentColor"/></CentralIconBase>;
});

export default IconBuildingBlocks;
